import React, { useRef } from "react";
import { email, wa_black, website_black } from "../assets";
import { QRCode } from "react-qrcode-logo";

const Signature = ({
  type = 0,
  profilePicture,
  name,
  jobPosition,
  company,
  email_val,
  whatsapp_val,
  address_val,
  qr,
  companyLogo,
  extraLogo,
  slug,
  isFix = false,
  ref_ = null,
}) => {
  const nullRef = useRef();
  const address_src =
    "https://cdn.nitomeyocard.com/asset/IMG6a34edb9254d4343b0160bd3acca421c.svg";
  return (
    <div
      className={`flex flex-col border p-5 aspect-90/23 shadow-lg ${isFix ? "w-[700px] bg-white" : "w-full"}`}
      ref={isFix ? ref_ : nullRef}
    >
      <div className="flex flex-row w-full gap-10">
        <div className="flex flex-col gap-2 justify-center items-center">
          {type > 0 ? (
            <img src={companyLogo} className="w-[200px]" />
          ) : (
            <img src={profilePicture} className="w-[200px] rounded-full" />
          )}
        </div>
        <div className="flex flex-col w-full gap-2">
          <div className="flex flex-col w-full">
            <div className="font-bold text-[18px]">{name}</div>
            <div>
              {jobPosition}
              {company && ` of ${company}`}
            </div>
          </div>
          <hr class="h-px bg-black border-0" />
          <div className="grid grid-cols-1 mt-2 gap-2">
            {email_val && (
              <div className="flex flex-row gap-2 items-center">
                <img
                  src={email}
                  className="w-[25px] p-[3px] rounded-lg border border-black"
                />
                <div className="text-[14px]">{email_val}</div>
              </div>
            )}
            {whatsapp_val && (
              <div className="flex flex-row gap-2 items-center">
                <img
                  src={wa_black}
                  className="w-[25px] p-[3px] rounded-lg border border-black"
                />
                <div className="text-[14px]">{whatsapp_val}</div>
              </div>
            )}

            {address_val && (
              <div className="flex flex-row gap-2 items-center col-span-full">
                <img
                  src={address_src}
                  className="w-[25px] p-[3px] rounded-lg border border-black"
                />
                <div className="text-[14px] text-wrap">{address_val}</div>
              </div>
            )}
          </div>
          {extraLogo && (
            <div className="flex flex-row gap-2 items-center mt-2">
              {extraLogo.map((val, ind) => (
                <img key={ind} src={val} className="w-[18px] rounded-md" />
              ))}
            </div>
          )}
        </div>
        <div className="flex flex-col gap-2 justify-center items-center">
          {type < 2 ? (
            <QRCode
              id={"qr"}
              value={"https://app.nitomeyocard.com/me/" + slug}
              size={107}
              qrStyle={"dots"}
              logoOpacity={0.15}
              bgColor={"transparent"}
              level={"H"}
              fgColor={"black"}
            />
          ) : (
            <img src={profilePicture} className="w-[200px] rounded-full" />
          )}
        </div>
      </div>
    </div>
  );
};

export default Signature;
